import React from "react";
import styled from "styled-components";
import Row from "../Row/Row";

interface QuantityPickerProps {
  value: number;
  max: number;
  onChange: (newValue: number) => void;
}

const StyledInput = styled.input`
  background: #14203f;
  border: 0.5px solid #ffffff90;
  border-radius: 6px;
  color: white;
  width: 30%;
  padding: 6%;

  text-align: center;
  font-size: large;
`;

const Control = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.5px solid #ffffff90;
  border-radius: 10px;
  font-size: 20px;
  padding: 5%;

  &:active {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
  }
  &:hover {
    cursor: pointer;
  }
`;
export const QuantityPicker: React.FC<QuantityPickerProps> = ({
  value,
  onChange,
  max,
}) => {
  const isNumeric = (value) => {
    return /^-?\d+$/.test(value);
  };

  const onIncrement = () => {
    if (value + 1 <= max) {
      onChange(value + 1);
    }
  };

  const onDecrement = () => {
    if (value - 1 >= 0) {
      onChange(value - 1);
    }
  };

  return (
    <Row align={"flex-start"} gap={'10px'}>
      <Control onClick={onDecrement}>-</Control>

      <StyledInput
        type="text"
        inputMode="numeric"
        value={value}
        max={max}
        onChange={(event) =>
          onChange(
            isNumeric(event.target.value)
              ? parseInt(event.target.value) <= max
                ? parseInt(event.target.value)
                : max
              : 0
          )
        }
      />
      <Control onClick={onIncrement}>+</Control>
    </Row>
  );
};
